<header>
  <dx-toolbar class="header-toolbar">
    @if (menuToggleEnabled) {
      <dxi-item
        location="before"
        widget="dxButton"
        cssClass="menu-button"
      [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }"
        >
      </dxi-item>
    }

    @if (title) {
      <dxi-item location="before" cssClass="header-title dx-theme-background-color-as-text-color" [text]="title"></dxi-item>
    }
    <dxi-item
      location="after"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{ icon: 'home', text: languageService.get('reports'), stylingMode: 'text', onClick: navigateToReports, type: 'normal' }"
      >
    </dxi-item>

    <dxi-item
      location="after"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{icon: 'help', text: languageService.get('help'), stylingMode: 'text', onClick: clickedHelp}">
    </dxi-item>

    <dxi-item location="after">
      <div *dxTemplate>
        @for (lang of languages; track lang) {
          <span (click)="changeLanguage(lang)" class="lang" [class.active]="activeLangguage(lang)">
            {{ lang }}
          </span>
        }
      </div>
    </dxi-item>

    @if (isAuthentecated()) {
      <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
        <div *dxTemplate="let data of 'item'">
          <dx-button class="user-button authorization" width="210px" height="100%" stylingMode="text">
            <div *dxTemplate="let data of 'content'">
              <app-user-panel [user]="user" [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
            </div>
          </dx-button>
        </div>
      </dxi-item>
    }
    <div *dxTemplate="let data of 'menuItem'">
      <app-user-panel [user]="user" [menuItems]="userMenuItems" menuMode="list"></app-user-panel>
    </div>

  </dx-toolbar>
</header>
